var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.fetching ? _c('div', {
    staticClass: "\n      text-center\n      d-flex\n      justify-content-center\n      align-items-center\n      fetching\n    "
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary"
    }
  })], 1) : _vm._e(), _vm.errorMessage ? _c('div', {
    staticClass: "container error-message-box justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h5', [_vm._v(_vm._s(_vm.errorMessage))]), _vm.$store.state.liffChatroom.user.outer_code ? _c('p', [_vm._v("錯誤代碼: " + _vm._s(_vm.$store.state.liffChatroom.user.outer_code))]) : _vm._e()])]) : [_vm.chatroom ? _c('div', {
    ref: "chatbox",
    staticClass: "chatbox flex-fill"
  }, [_c('header', {
    staticClass: "\n          d-flex\n          justify-content-center\n          align-items-center\n          sticky-top\n          border-bottom\n        "
  }, [_c('h1', [_c('b-avatar', {
    staticClass: "mr-2",
    attrs: {
      "src": _vm.chatroom.avatar_url,
      "variant": "light"
    }
  }), _vm._v(" " + _vm._s(_vm.chatroom.title) + " ")], 1)]), _c('div', {
    staticClass: "\n          chatbox-inner\n          d-flex\n          flex-column-reverse\n          px-3\n          position-relative\n        "
  }, [_c('div', {
    staticClass: "upload-btn-container"
  }, [!_vm.sending && !_vm.uploaded && !_vm.leaved ? _c('div', {
    staticClass: "inner-upload"
  }, [_c('span', [_vm._v("請選擇你要上傳的檔案")]), _c('br'), _c('button', {
    staticClass: "btn upload-btn",
    attrs: {
      "disabled": _vm.sending
    },
    on: {
      "click": _vm.selectFile
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/liff/chatbox/paperclip-2.png"),
      "width": "25",
      "height": "25"
    }
  }), _vm._v(" 選擇檔案 ")])]) : _vm._e(), _vm.sending && !_vm.leaved ? _c('div', {
    staticClass: "inner-upload"
  }, [_c('b-spinner', {
    staticClass: "upload-spinner mb-3",
    attrs: {
      "variant": "primary"
    }
  }), _c('span', [_vm._v("上傳 " + _vm._s(_vm.filesLength) + " 個檔案中...")]), _c('br'), _c('br'), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("請勿關閉視窗，避免傳送失敗")]), _c('br'), _c('br'), _vm.filesLength === 1 ? _c('span', [_vm._v("如果您選擇多個檔案但系統只上傳一個檔案，")]) : _vm._e(), _c('br'), _vm.filesLength === 1 ? _c('span', [_vm._v("代表您的瀏覽器不支援多檔上傳，請分多次上傳。")]) : _vm._e()], 1) : _vm._e(), _vm.uploaded && !_vm.leaved ? _c('div', {
    staticClass: "inner-upload"
  }, [_c('span', [_vm._v("上傳成功，請點下方回到聊天室")]), _c('br'), _c('button', {
    staticClass: "btn btn-primary-blue upload-btn",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(" 回聊天室 ")])]) : _vm._e(), _vm.leaved ? _c('div', {
    staticClass: "inner-upload"
  }, [_c('span', [_vm._v("本次上傳作業已結束，")]), _c('br'), _c('span', [_vm._v("請點下方回到聊天室，或關閉本視窗。")]), _c('br'), _c('button', {
    staticClass: "btn btn-primary-blue upload-btn",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(" 回聊天室 ")])]) : _vm._e()])]), _c('div', {
    staticClass: "typebox py-2 px-3 bg-white border-top"
  }, [_c('input', {
    ref: "file",
    staticClass: "sr-only",
    attrs: {
      "type": "file",
      "multiple": !_vm.isSamsung
    },
    on: {
      "change": _vm.uploadFile
    }
  }), _c('form', {
    staticClass: "textbox",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "btn-container"
  }, [!_vm.leaved ? _c('button', {
    staticClass: "btn item",
    attrs: {
      "disabled": _vm.sending
    },
    on: {
      "click": _vm.selectFile
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/liff/chatbox/paperclip-2.png"),
      "width": "25",
      "height": "25"
    }
  }), _vm._v(" 選擇檔案 ")]) : _vm._e(), _c('button', {
    staticClass: "btn item",
    class: {
      'btn-primary-blue': _vm.uploaded
    },
    staticStyle: {
      "height": "33px"
    },
    attrs: {
      "disabled": _vm.sending
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v(" 回聊天室 ")])])])])]) : _vm._e()]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }